import { type Translationtype } from "utils";
import { BiSolidXCircle } from "react-icons/bi";
import { BasicModalContent } from "./modalContent/BasicModalContent";
import { MagicAiModalContent } from "./modalContent/MagicAiModalContent";

interface IJinnyMagicAiModalProps {
  t: Translationtype;
  locale: any;
  hasPremium: boolean;
  show: boolean;
  onHide: VoidFunction;
}

export function JinnyMagicAiModal({
  t,
  locale,
  hasPremium,
  show,
  onHide,
}: IJinnyMagicAiModalProps) {
  if (!show) {
    return null;
  }
  return (
    <div className="fixed bottom-3 right-2 z-50 rounded-[24px] drop-shadow-x overflow-hidden w-[95vw] max-w-[320px] md:max-w-[390px] h-max">
      <div className="relative bg-[#374151] p-8">
        {hasPremium ? (
          <MagicAiModalContent t={t} />
        ) : (
          <BasicModalContent t={t} locale={locale} />
        )}
        <BiSolidXCircle
          className="absolute top-3 right-3 text-white text-xl md:text-2xl cursor-pointer"
          onClick={() => onHide()}
        />
      </div>
    </div>
  );
}
